/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { MetaMcpMember, MetaMcpMember$inboundSchema } from "./metamcpmember.js";

/**
 * Result type for listing meta MCP members
 */
export type ListMetaMcpMembersResult = {
  members: Array<MetaMcpMember>;
};

/** @internal */
export const ListMetaMcpMembersResult$inboundSchema: z.ZodMiniType<
  ListMetaMcpMembersResult,
  unknown
> = z.object({
  members: z.array(MetaMcpMember$inboundSchema),
});

export function listMetaMcpMembersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListMetaMcpMembersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListMetaMcpMembersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListMetaMcpMembersResult' from JSON`,
  );
}
